<app-desktop-nav class="hidden lg:block sticky top-0 z-50 bg-white/80 backdrop-blur-sm shadow-sm"
    [navItems]="navItems()" [themeItem]="themeItem" [accountMenuItems]="accountMenuItems()"
    [username]="username"></app-desktop-nav>
<app-mobile-nav 
    [navItems]="navItems()" 
    [themeItem]="themeItem" 
    [accountMenuItems]="accountMenuItems()"
    [username]="username"></app-mobile-nav>
<p-dialog header="Accessibility" [modal]="true" [draggable]="false" [resizable]="true"
[breakpoints]="{'9999px': '40vw', '1199px': '75vw', '575px': '90vw' }"  [(visible)]="showAccessibilityDialog"
    >
    <div class="flex flex-col gap-4">

        
            <p>The UserWay Accessibility Widget provides a range of tools to help you customize your browsing experience. With it, you can adjust settings 
                like text size, contrast, and navigation to make the site more accessible for your needs. 
            </p>

            <p>
                <span class="font-bold">Please note:</span> these features can sometimes slow down certain pages, especially the trip staffing tool.  If you experience any issues, please 
                disable the feature.  You can re-enable it at any time.
            </p>

            @if(accessibilityEnabled()) {
                <span class="font-bold">The accessibility widget is currently enabled.</span>  To turn off all accessibility features, click the "Disable" button below.  The current page will be refreshed.
            }
            @else {
                <span class="font-bold">The accessibility widget is currently disabled.</span>  To enable accessibility features, click the "Enable" button below. The UserWay Accessibility Widget will be added to the bottom right of thepage.
            }
        

        <div class="flex justify-end gap-2">
            @if(accessibilityEnabled()) {
                <p-button label="Disable" (onClick)="disableAccessibility()"></p-button>
            }
            @else {
                <p-button label="Enable" (onClick)="enableAccessibility()"></p-button>
            }
        </div>
    </div>
</p-dialog>